import axios from 'axios'
import * as types from './types'

export default {
  [types.OPEN_NEW_FRANCHISE_MANUAL_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_NEW_FRANCHISE_MANUAL_SIDEBAR, { ...payload, visible: true })
  },
  [types.OPEN_PUBLISH_MANUAL_VERSION_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_PUBLISH_MANUAL_VERSION_SIDEBAR, { ...payload, visible: true })
  },
  [types.CREATE_FRANCHISE_MANUAL]: ({}, payload) => {
    return axios
      .post('/api/franchise_manuals', payload)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.UPDATE_FRANCHISE_MANUAL]: ({}, { id, ...payload }) => {
    return axios
      .post(`/api/franchise_manuals/${id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.PUBLISH_FRANCHISE_MANUAL_VERSION]: ({}, { id, request }) => {
    return axios
      .post(`/api/franchise_manuals/${id}/versions`, request)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.GET_FRANCHISE_MANUAL]: ({}, payload) => {
    return axios
      .get(`/api/franchise_manuals/${payload}`)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.SEARCH_FRANCHISE_MANUALS]: ({ commit }, payload) => {
    return axios
      .post('/api/franchise_manuals/search', payload)
      .then((resp) => {
        commit(types.MUTATE_FRANCHISE_MANUALS_SEARCH_RESULT, resp.data)
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.TOGGLE_FRANCHISE_MANUAL_STATUS]: ({}, payload) => {
    return axios
      .patch(`/api/franchise_manuals/status/${payload}`)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  // Só franqueado planejador e franqueado de expansão recebem manuais —
  // endpoint próprio, não o de tipos de contrato de PN em geral.
  [types.GET_FRANCHISE_CONTRACT_TYPE_OPTIONS]: ({}) => {
    return axios
      .get('/api/franchise_manuals/contract_type_options')
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.GET_MY_FRANCHISE_MANUAL_CYCLE]: ({ commit }) => {
    return axios
      .get('/api/franchise_manual_cycles/my_cycle')
      .then((resp) => {
        commit(types.MUTATE_MY_FRANCHISE_MANUAL_CYCLE, resp.data)
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.CONFIRM_FRANCHISE_MANUAL_RECEIPT]: ({ commit }) => {
    return axios
      .post('/api/franchise_manual_cycles/my_cycle/confirm_receipt')
      .then((resp) => {
        commit(types.MUTATE_MY_FRANCHISE_MANUAL_CYCLE, resp.data)
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.CONFIRM_FRANCHISE_MANUAL_READING]: ({ commit }) => {
    return axios
      .post('/api/franchise_manual_cycles/my_cycle/confirm_reading')
      .then((resp) => {
        commit(types.MUTATE_MY_FRANCHISE_MANUAL_CYCLE, resp.data)
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.SEARCH_FRANCHISE_MANUAL_COMPLIANCE]: ({}, payload) => {
    return axios
      .post('/api/franchise_manual_cycles/admin/search', payload)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
  [types.GET_FRANCHISE_MANUAL_HISTORY]: ({}, userId) => {
    return axios
      .get(`/api/franchise_manual_cycles/admin/user/${userId}/history`)
      .then((resp) => {
        return Promise.resolve(resp)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },
}
